// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_option from "../../../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CountryContext from "../../../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as PpAccordionFooter from "../PpAccordionFooter.bs.js";
import * as Accordion$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/Accordion.bs.js";
import * as DriverRecordsStore from "../../DriverRecordsStore.bs.js";
import * as AccordionAPIWrapper from "../../../../vm-mapper/driver-records/AccordionSections/AccordionAPIWrapper.bs.js";
import * as DriverProofViewMapper from "../../../../vm-mapper/driver-records/DriverProofViewMapper.bs.js";
import * as BrandingInfoViewMapper from "../../../../vm-mapper/driver-records/BrandingInfoViewMapper.bs.js";
import * as AccordionTypes$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/AccordionTypes.bs.js";
import * as CircularLoader$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";
import * as PremiumPartnerViewMapper from "../../../../vm-mapper/driver-records/PremiumPartnerViewMapper.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";
import * as SectionHeaderComponent$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/section-header/SectionHeaderComponent.bs.js";

function getAccordionPanels(driverInfo, workspace_dispatch, partnerDocument, premiumPartnerReport, msisdn, dispatch, uuid, country) {
  return {
          hd: AccordionTypes$Catalyst.make_props({
                TAG: /* Text */0,
                _0: "Driver Proofs"
              }, undefined, (function (param) {
                  return AccordionAPIWrapper.fetchUnloadedData(partnerDocument, (function (param) {
                                return DriverRecordsStore.loadPartnerDocumentsData(uuid, dispatch, country);
                              }));
                }), DriverProofViewMapper.getView(partnerDocument), undefined),
          tl: {
            hd: AccordionTypes$Catalyst.make_props({
                  TAG: /* Text */0,
                  _0: "Branding Info"
                }, undefined, undefined, BrandingInfoViewMapper.getView(driverInfo), undefined),
            tl: {
              hd: AccordionTypes$Catalyst.make_props({
                    TAG: /* Text */0,
                    _0: "Premium Membership Subscription"
                  }, Caml_option.some(React.createElement(PpAccordionFooter.make, {
                            msisdn: msisdn,
                            premiumPartnerReport: premiumPartnerReport,
                            workspace_dispatch: workspace_dispatch
                          })), (function (param) {
                      return AccordionAPIWrapper.fetchUnloadedData(premiumPartnerReport, (function (param) {
                                    return DriverRecordsStore.loadPremiumPartnerReports(msisdn, dispatch, country);
                                  }));
                    }), PremiumPartnerViewMapper.getView(premiumPartnerReport), undefined),
              tl: /* [] */0
            }
          }
        };
}

function MiscellaneousInfoSection(Props) {
  var driverInfo = Props.driverInfo;
  var partnerDocument = Props.partnerDocument;
  var premiumPartnerReport = Props.premiumPartnerReport;
  var workspace_dispatch = Props.workspace_dispatch;
  var msisdn = Props.msisdn;
  var dispatch = Props.dispatch;
  var match = CountryContext.useContext(undefined);
  switch (driverInfo.TAG | 0) {
    case /* Loading */0 :
        return React.createElement(CircularLoader$Catalyst.make, {});
    case /* Live */1 :
        return React.createElement("div", {
                    className: "section-container"
                  }, React.createElement(SectionHeaderComponent$Catalyst.make, {
                        heading: "Miscellaneous Info"
                      }), React.createElement(Accordion$Catalyst.make, {
                        panels: getAccordionPanels(driverInfo, workspace_dispatch, partnerDocument, premiumPartnerReport, msisdn, dispatch, driverInfo._0.driverProfile.uuid, match.country),
                        className: "accordion-container"
                      }));
    case /* Error */2 :
        return React.createElement(ErrorDisplayComponent$Catalyst.make, {
                    error: driverInfo._0
                  });
    
  }
}

var make = MiscellaneousInfoSection;

export {
  getAccordionPanels ,
  make ,
  
}
/* react Not a pure module */
